// Caracal Studio (15 October 2026): a product card swaps to photo 2 on hover, but photo 2 loaded only on hover,
// so the swap came late. After the page has loaded, computers with a mouse fetch photo 2 of every card.
// ponytail: cards added later (filters, "You may also like") still load photo 2 on hover.
addEventListener('load', () => {
  if (!matchMedia('(hover: hover)').matches) return;
  document.querySelectorAll('.card-gallery slideshow-slide:nth-of-type(2) img[loading="lazy"]').forEach((img) => {
    img.sizes = img.sizes.replace(/^auto,\s*/, ''); // "auto" works only for lazy photos; without this the photo loads at 1600 px
    img.loading = 'eager';
  });
});
